import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

bootstrapApplication(App, appConfig).catch((err) => {
  console.error(err);
  const message = 'CMS could not start. Please refresh the page or contact support.';
  const status = document.getElementById('cms-bootstrap-status');

  if (status) {
    status.replaceChildren(message);
    return;
  }

  document.querySelector('app-root')?.replaceChildren(message);
});
